import React, { Suspense, lazy, useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { TriggerLink } from '../../TriggerLink';
import { ProductFinishingOptionsData } from '../types/';

const FinishingOptionsModalView = lazy(() =>
  import('./FinishingOptionsModalView').then((m) => ({ default: m.FinishingOptionsModalView }))
);

export interface FinishingOptionsProps {
  data: ProductFinishingOptionsData;
  trigger: React.ReactNode;
}

export const FinishingOptions: React.FC<FinishingOptionsProps> = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTriggerOnClick = () => setIsModalOpen(true);

  return (
    shouldRender(props) && (
      <>
        <TriggerLink onTriggerOnClick={handleTriggerOnClick} trigger={props.trigger} />
        {isModalOpen && (
          <ErrorBoundary fallback={null} onError={() => setIsModalOpen(false)}>
            <Suspense fallback={null}>
              <FinishingOptionsModalView
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                data={props.data}
              />
            </Suspense>
          </ErrorBoundary>
        )}
      </>
    )
  );
};

export const shouldRender = (props: Partial<Pick<FinishingOptionsProps, 'data'>>) => {
  return !!props.data?.isEnabled;
};
